module.exports = __webpack_public_path__ + "static/img/km.86e906fc.svg";